export default __webpack_public_path__ + "static/media/panelM6.5fbd351d.png";